module.exports = __webpack_public_path__ + "images/credit.png";